module.exports = __webpack_public_path__ + "static/img/装饰11.8be256a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰11.svg
// module id = bHwz
// module chunks = 2